/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Prices
 */
export interface Prices {
    /**
     * 
     * @type {string}
     * @memberof Prices
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Prices
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof Prices
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof Prices
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Prices
     */
    period: number;
    /**
     * 
     * @type {string}
     * @memberof Prices
     */
    periodUnit: string;
    /**
     * 
     * @type {string}
     * @memberof Prices
     */
    paymentPage: string;
}

/**
 * Check if a given object implements the Prices interface.
 */
export function instanceOfPrices(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "period" in value;
    isInstance = isInstance && "periodUnit" in value;
    isInstance = isInstance && "paymentPage" in value;

    return isInstance;
}

export function PricesFromJSON(json: any): Prices {
    return PricesFromJSONTyped(json, false);
}

export function PricesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prices {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'currency': json['currency'],
        'price': json['price'],
        'name': json['name'],
        'period': json['period'],
        'periodUnit': json['periodUnit'],
        'paymentPage': json['paymentPage'],
    };
}

export function PricesToJSON(value?: Prices | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'currency': value.currency,
        'price': value.price,
        'name': value.name,
        'period': value.period,
        'periodUnit': value.periodUnit,
        'paymentPage': value.paymentPage,
    };
}

